module.exports = __webpack_public_path__ + "img/block-1.1523d97a.svg";